<template>
  <!--筛选器-->
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="search-group-file-filter"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <i class="iconfont icon-close"></i>
          </button>
          <h4 class="modal-title" id="myModalLabel">筛选器</h4>
        </div>
        <div class="modal-body">
          <div class="input-group form-group">
            <span
              class="input-group-addon"
              id="basic-addon1"
              style="background-color: #eee"
              data-toggle="dropdown"
              >{{ searchText[searchType] }} <span class="caret"></span
            ></span>
            <ul class="dropdown-menu">
              <li :class="{ active: searchType === 'file' }">
                <a @click="toggleSearch('file')">文件名</a>
              </li>
              <li :class="{ active: searchType === 'folder' }">
                <a @click="toggleSearch('folder')">文件夹名</a>
              </li>
            </ul>
            <input
              type="text"
              class="form-control"
              :placeholder="'输入' + searchText[searchType] + '，进行模糊搜索'"
              style="padding-left: 12px"
              v-model="query.searchName"
              v-on:keyup.enter="search"
            />
          </div>
          <div class="form-group" v-show="showFirstLevelFolder">
            <p style="color: gray">
              {{ msg5021 }}
            </p>
            <select
              class="form-control selectpicker"
              v-model="query.first_level_folder"
            >
              <option
                v-for="(item, index) in firstLevelFolders"
                :key="index"
                :value="item.id"
              >
                {{ item.folder_name }}
              </option>
            </select>
          </div>
          <div class="form-group clearfix">
            <div class="datebox">
              <input
                @focus="getFormatDateFocus('setEndDate', $event)"
                class="form-control"
                placeholder="选择时间"
                type="text"
                v-model="query.search_start_date"
              />
            </div>
            <div class="datebox">--</div>
            <div class="datebox">
              <input
                @focus="getFormatDateFocus('setStartDate', $event)"
                class="form-control"
                placeholder="选择时间"
                type="text"
                v-model="query.search_end_date"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">
            取消
          </button>
          <button class="btn btn-default" type="button" @click="clear">
            重置
          </button>
          <button class="btn btn-primary" type="button" @click="search">
            搜索
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFormatDate } from "@/utils/index";
export default {
  name: "SearchGroupFileFilter",
  props: {
    group_number: {
      type: String,
      default: "",
    },
    searchType: {
      type: String,
      default: "file",
    },
  },
  data() {
    return {
      searchText: {
        file: "文件名",
        folder: "文件夹名",
      },
      startDate: "",
      endDate: "",
      query: {
        disk_type: "cloud",
        offset: 0,
        limit: null, // 不限制每页数量，搜索全部
        group_number: "",
        category: "file",
        search_start_date: "",
        search_end_date: "",
        searchName: null,
        first_level_folder: "",
      },
      showFirstLevelFolder: false,
      firstLevelFolders: [],
      msg5021: "",
    };
  },
  created() {
    this.query.group_number = this.group_number;
  },
  watch: {
    "query.searchName": {
      handler: function () {
        this.showFirstLevelFolder = false;
        this.firstLevelFolders = [];
        this.query.first_level_folder = "";
      },
    },
  },
  methods: {
    toggleSearch(searchType) {
      this.$emit("toggleSearch", searchType);
      this.query.category = searchType;
    },
    clear() {
      this.query.searchName = "";
      this.query.search_start_date = "";
      this.query.search_end_date = "";
    },
    search() {
      this.$store
        .dispatch("searchGroupFileByFilter", this.query)
        .then((res) => {
          if (res.status_code === 5021) {
            this.firstLevelFolders = res.entity;
            this.query.first_level_folder = this.firstLevelFolders[0].id;
            this.showFirstLevelFolder = true;
            this.msg5021 = res.message;
          }
        });
    },
    getFormatDateFocus(setDate = "setEndDate", event) {
      let that = this;
      $(event.currentTarget)
        .datetimepicker({
          format: "yyyy-mm-dd",
          weekStart: 1,
          autoclose: true,
          startView: 2,
          minView: 2,
          pickerPosition: "top-right",
          language: "zh-CN",
        })
        .datetimepicker(
          setDate,
          setDate === "setEndDate" ? this.endDate : this.startDate
        )
        .datetimepicker("show")
        .on("changeDate", function (ev) {
          let day = getFormatDate(ev.date.valueOf());
          if (setDate === "setEndDate") {
            that.query.search_start_date = day;
            that.startDate = day;
          } else {
            that.query.search_end_date = day;
            that.endDate = day;
          }
        })
        .on("hide", function (ev) {
          $(ev.currentTarget).datetimepicker("remove");
        });
    },
  },
  mounted() {
    $("#search-group-file-filter").on("show.bs.modal", () => {});
  },
  destroyed() {
    $("#search-group-file-filter").off();
  },
};
</script>

<style scoped>
#basic-addon1 {
  cursor: pointer;
}
</style>